export enum Answer {
  NoneOfTheTime = "None of the time",
  Rarely = "Rarely",
  SomeOfTheTime = "Some of the time",
  Often = "Often",
  Everyday = "Everyday",
}
